<template>
    <div class="dynamic-block-container mt-4 mt-xl-0">
        <button
            type="button"
            class="btn btn-primary"
            @click="addMore()"
        >
            Add Text Block
        </button>
        <div v-if="blocks.length" class="text-form">
            <div v-for="(block, index) in blocks" :key="index" class="wrapper-dynamic-block-input" >
                <div class="d-flex justify-content-between align-items-end col-12 mt-2 ">
                    <div class="d-flex align-items-center justify-content-center col-1">
                        <button
                            type="button"
                            class="btn btn-outline-primary p-2 "
                            @click="remove(index)">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                <div class="col-6">
                    <p class="mb-2 main-text text-muted">Enter text for title</p>
                    <input name="field-title" v-model="block.fieldName"
                       placeholder="Enter field name"
                       class="custom-input me-2"
                    />
                </div>
                <div class="col-4">
                    <p class="mb-2 main-text text-muted">Choose field type</p>
                    <v-select v-model="block.selected" :options="chooseField" label="field" class="" :clearable="false"/>
                </div>
                </div>
                <div class="d-flex justify-content-between align-items-end col-12 mt-2">
                <div v-if="block.selected.code === 1" class="col-2">
                    <p class="mb-2 main-text text-muted">Enter limit of symbols</p>
                    <input name="field-title" v-model="block.fieldLimit.input"
                           type="number"
                           placeholder=""
                           class="custom-input me-2"
                           value="1"
                           min="1"
                    />
                </div>
                    <div v-if="block.selected.code === 2" class="col-3 d-flex">
                        <div class="me-1">
                        <p class="mb-2 main-text text-muted">Rows limit</p>
                        <input name="field-title" v-model="block.fieldLimit.textArea.row"
                               type="number"
                               placeholder=""
                               class="custom-input me-2"
                               value="1"
                               min="1"
                        />
                        </div>
                        <div>
                            <p class="mb-2 main-text text-muted">Limit in row</p>
                            <input name="field-title" v-model="block.fieldLimit.textArea.symbol"
                                   type="number"
                                   placeholder=""
                                   class="custom-input me-2"
                                   value="1"
                                   min="1"
                            />
                        </div>
                    </div>

                    <div class="col-5">
                        <p class="mb-2 main-text text-muted">Font family</p>
                        <v-select v-model="block.fontFamily" :options="chooseFont" class="" :clearable="false"/>
                    </div>
                    <div class="">
                        <p class="mb-2 main-text text-muted">Font size</p>
                        <v-select v-model="block.fontSize" :options="chooseFontSize" class="" :clearable="false"/>
                    </div>
                    <v-swatches
                        v-model="block.color"
                        show-fallback
                        fallback-input-type="color"
                        row-length="6"
                        swatch-size="20"
                        shapes="circles"
                        popover-x="left"
                        popover-y="top"
                    ></v-swatches>
                </div>
                <div class="col-5">
                    <p class="mb-2 main-text text-muted">Text position</p>
                    <v-select v-model="block.textPosition" :options="choosePosition" class="" :clearable="false"/>
                </div>
                <div class="d-flex justify-start ml-2 mt-2 mb-4">
                    <input v-if = "block.selected.code === 1"
                        v-model="block.inputText"
                        placeholder="Enter you text"
                        class="custom-input"
                    />
                    <textarea v-else-if="block.selected.code === 2"
                              v-model="block.inputText"
                              placeholder="enter you text"
                              class="custom-input"
                    ></textarea>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'
export default {
    name: "DynamicInput",
    components: {
        vSelect,
        VSwatches,
    },
    props: ['blocks'],
    data() {
        return {
            chooseField:[
                {code: 1, field: 'input'},
                {code: 2, field: 'text area'},
            ],
            choosePosition:[ 'start','center', 'end'],
            chooseFont:['Chouse font',"WitchMystery","Tree-Night","TheWiseLove","The-Billion", "The-Billion-Monoline", "Sweet-Bonia", "Sunny-Spells", "Stigma-Display-Typeface", "SOMETHING", "Snowy", "SchoolChalk", "SayHello", "Rossie", "PlayInk", "PlaceStar","Pinky", "Old-Whiskey-base", "Old-Whiskey-glow", "NewPose", "Mustard-Bold", "Mustard-Medium", "Morning-Miow", "Morning-Miow-Outline", "Montage-Serif-Font", "Mike-Boom", "Memories", "Mangelo", "Loving", "Little-Things", "Little-Things-Script", "Lightning-Script", "Laisha", "Klotee", "Kinder-Journey", "KidsToys", "HollaWeekend","HelloRainbow", "Harshita", "gravity1", "gravity2", "gravity3", "gravity4", "Grafity-Sample-Ligatures","Grafity-SampleSS1", "Gravity-SampleSS2", "Girl", "FonttSetya", "Florida-Palm", "Find-Joy", "Dandelion", "Daily-Book-Inline", "Daily-Book-Stripe", "ComicCaps", "ComicaBoom", "ChildWriting", "Cheque","Cheque-Black", "Charrie", "Carved-Wood-Regular","Carved-Wood", "BrittanyCharming", "Bright-Dreams", "Bridgetown", "Better-Together-Script", "Better-Together", "BeforetheRainbow", "BeautifulHumility", "BarokahSignature", "Arnitta-Callina", "Angista-Script", "Anastasia", "AmazingQuirky", "Always_Amora", "Advantage",
                'Fiesta-Rumba', 'Sanies-Script', 'Cormorant-Bold', 'Cormorant-BoldItalic', 'Cormorant-Italic', 'Cormorant-Light', 'Cormorant-LightItalic', 'Cormorant-Medium', 'Cormorant-MediumItalic', 'Cormorant-Regular', 'Cormorant-SemiBold', 'Cormorant-SemiBoldItalic', 'Chin-up-Buttercup', 'Chin-up-Buttercup-CuteCaps', 'Chin-up-Buttercup-Elements', 'Chin-up-Buttercup_alt', 'Chin-up-Buttercup_extrachar', 'AvenirNextCondensed-bold','AvenirNextCondensed-bold-italic', 'AvenirNextCondensed-demi-bold', 'AvenirNextCondensed-demi-bold-italic','AvenirNextCondensed-heavy', 'AvenirNextCondensed-heavy-italic', 'AvenirNextCondensed-italic', 'AvenirNextCondensed-medium', 'AvenirNextCondensed-medium-italic','AvenirNextCondensed-regular', 'AvenirNextCondensed-ultra-light', 'AvenirNextCondensed-ultra-light-italic', 'AvenirNext-bold', 'AvenirNext-bold-italic', 'AvenirNext-demi-bold', 'AvenirNext-demi-bold-italic', 'AvenirNext-heavy', 'AvenirNext-heavy-italic', 'AvenirNext-italic', 'AvenirNext-medium', 'AvenirNext-medium-italic', 'AvenirNext-regular', 'AvenirNext-ultra-light', 'AvenirNext-ultra-light-italic', 'montserrat-black', 'montserrat-black-italic', 'montserrat-bold', 'montserrat-bold-italic', 'montserrat-extra-bold', 'montserrat-extra-bold-italic', 'montserrat-extra-light', 'montserrat-extra-light-italic', 'montserrat-light', 'montserrat-light-italic', 'montserrat-medium-italic', 'montserrat-semi-bold', 'montserrat-semi-bold-italic', 'montserrat-thin', 'montserrat-thin-italic', 'montserrat-regular', 'montserrat-medium','amatic-bold', 'amatic-regular', 'angelia', 'bellatrix', "bigelowrules", "blackline", "cabinsketchbold", "cabinsketchregular", "iloveyou", "kastingscript", "lifesaversbold", "lifesaversextrabold", "lifesaverregular", "lofty", "mauntains", "maybecoffee", "nanumpenscript", "nunitoitalic", "nunitoregular", "poiretone", "qwitchergrypenbolt", "qwitchergrypenregular", "ribeyemarrow", "sacramento", "shears", "thankfully", "weddingonholiday", "weddingvintage", "welcome", "londonhistory", "londonhistory-sans", "natali", "nathan", "quentin", "stronggirls", "dawningofanewday"],
            chooseFontSize:['8px', '9px', '10px', '12px', '14px', '16px', '20px', '24px', '32px', '42px', '54px', '68px', '84px', '98px', '112px', '126px', '140px', '154px', '168px', '182px'],
        };
    },
    methods: {
        addMore() {
            this.$emit('addNewBlock',
            {
                fieldName: "",
                fieldLimit: {
                    input:1,
                    textArea:{row:1, symbol:1}
                },
                textPosition: 'start',
                fontFamily:'amatic-regular',
                fontSize:'14px',
                inputText: "",
                color:'#000000',
                selected:{code: 1, field: 'input'},
                id:Date.now(),
                transform: { x: 0, y: 0, width: 100, height: 100, rotation: 0 },
                active: false
            });
        },
        remove(index) {
            this.$emit('removeBlock', index);
        },
    }
};
</script>

<style lang="scss">
.dynamic-block-container {
    z-index: 4;
    width: 100%;
    margin-bottom: 15px;
    @media screen and (min-width: 1200px){
        width: 50%;
        margin-bottom: 0;
    }
}
.wrapper-dynamic-block-input{
    //border: 1px solid #000;
    margin: 5px;
    margin-bottom: 16px;
    padding: 13px;
    -webkit-box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.47);
    -moz-box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.47);
    box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.47);
}
.text-form{
    margin-top: 10px;
    max-height: 545px;
    min-width: 370px;
    overflow: scroll;
    padding: 1rem 0.5rem;
    border: 1px solid #cdcdcd;
    border-radius: 0.25rem;
}
.custom-input{
    border-radius: 0.25rem;
    padding: 0.3rem 0.4rem;
    border:1px solid #cdcdcd;
    width: 100%;
    outline: none;
    font-family: montserrat-medium;
    font-weight: 500;
    font-size: 12px;
    line-height: 17px;
    &::placeholder{
        font-family: montserrat-medium;
        font-weight: 500;
        font-size: 12px;
        line-height: 17px;
    }
}
.vs__dropdown-toggle{
    padding: 0 0 2px !important;
}

</style>
